import Vue from 'vue';
import store from './../../store';
import productTransformer from './../../transformers/product';

const success = ({ data }, resolve) => {
  const products = productTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllProducts', products);
  resolve(products);
};

const failed = () => {
};


export default type => (
  new Promise((resolve, reject) => {
    let url = '/products';
    if (type) {
      url += `?type=${type}`;
    }
    Vue.$http.get(url)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/product/all.js